import React, { useState } from "react";
import {
  Select,
  Button,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneHotel } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiDollarSign, FiPlus, FiStar } from "react-icons/fi";
import { FaHotel } from "react-icons/fa";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const hotel: any = getOneHotel();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const hotel_id = hotel?.hotel_id;
  const [title, setTitle] = useState<any>(hotel?.title);
  const [thumbnail, setThumbnail] = useState<any>(hotel?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(hotel?.image_cdn_id);
  const [venue, setVenue] = useState<any>(hotel?.venue);
  const [rating, setRating] = useState<any>(hotel?.rating);
  const [email, setEmail] = useState<any>(hotel?.email_address);
  const [payLink, setPayLink] = useState<any>(hotel?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(hotel?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(hotel?.whatsapp);
  const [facebook, setFacebook] = useState<any>(hotel?.facebook);
  const [twitter, setTwitter] = useState<any>(hotel?.twitter);
  const [instagram, setInstagram] = useState<any>(hotel?.instagram);
  const [youtube, setYoutube] = useState<any>(hotel?.youtube);
  const [hashtags, setHashtags] = useState<any>(hotel?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(hotel?.google_map_code);
  const [latitude, setLatitude] = useState<any>(hotel?.latitude);
  const [longitude, setLongitude] = useState<any>(hotel?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    hotel?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(hotel?.featured);
  const [promoted, setPromoted] = useState<any>(
    hotel?.promoted ? hotel?.promoted : "no"
  );
  const [hotelStatus, setHotelStatus] = useState<any>(hotel?.status);
  const [description, setDescription] = useState<any>(hotel?.description);
  const [collection, setCollection] = useState<any>(
    hotel?.HotelRestauDescriptions ? hotel?.HotelRestauDescriptions : []
  );
  const [expo, setExpo] = useState<any>(hotel?.expo);
  const [showTop, setShowTop] = useState<any>(hotel?.show_top);
  const [exteriorImages, setExteriorImages] = useState<any>(
    hotel?.exterior_images
  );
  const [pricing, setPricing] = useState<any>(hotel?.Pricings);

  const [showModal, setShowModal] = useState(false);
  const [showExtImages, setShowExtImages] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const hotelRoutes = "/data/hotel";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneHotelHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : hotel?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      rating: rating,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: hotelStatus,
      featured: featured,
      promoted: promoted,
      subdata: collection?.length > 0 ? collection : [],
      expo: expo,
      show_top: showTop,
      exterior_images: exteriorImages?.filter((x: any) => x?.thumbnail !== null),
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: hotel_id,
      data: data,
      content: _TYPES_.HOTEL,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={hotelRoutes}
      eyebrow="DoSee Data • Hotels"
      title="Edit Hotel"
      subtitle={`Update a hotel, resort or stay in ${entry_label || "this destination"}.`}
      icon={<FaHotel className="h-5 w-5" />}
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
          <ExteriorImages
            exteriorImages={exteriorImages}
            setExteriorImages={setExteriorImages}
            showModal={showExtImages}
            onClick={() => setShowExtImages(false)}
          />
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneHotelHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="The hero image for this hotel."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.HOTELS)}
        />
      </AddSection>

      <AddSection title="Hotel Details" hint="Name, area, rating and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              placeholder: "e.g., LakeView Resort & Spa",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Hotels",
              option: ["no", "yes"],
              preselect:
                showTop !== null && showTop !== undefined
                  ? [{ name: showTop === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              placeholder: "Neighborhood / Area",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              placeholder: "Street, City, Region",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "rating",
              title: "Rating",
              type: "text",
              value: rating || "",
              placeholder: "e.g., 4.5",
              onChange: (e: any) => {
                setRating(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="hotel_status"
        setStatus={setHotelStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={hotelStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Galleries & Extras"
        hint="Optional interior/exterior photos and amenity sub-collections."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <div className="flex flex-wrap items-center gap-3">
          <Button
            props={{
              type: "button",
              title: "Change Inter. / Exter. Images",
              category: "default",
              action: "edit",
              onClick: () => setShowExtImages(true),
            }}
          />
          <Button
            props={{
              type: "button",
              title: "Change More Details",
              category: "default",
              action: "edit",
              onClick: () => setShowModal(true),
            }}
          />
          {(exteriorImages?.length > 0 || collection?.length > 0) && (
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">
              <FiStar className="h-3 w-3" />
              {exteriorImages?.length || 0} images · {collection?.length || 0}{" "}
              extras
            </span>
          )}
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
